import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
    IWorkOrder,
    IWorkOrderMission,
    IProductionLine,
    IComponent,
    WorkOrderMissionType,
} from "@/models";

@Component({
    name: "notificationMission",
})

export default class NotificationMission extends Vue {

    @Prop({ required: true, type: Number })
    public workOrderMissionId: number;

    public showButtons: boolean;
    public cancelReason: string;

    public get woMission(): IWorkOrderMission {
        return this.$store.getters["productionLines/getWorkOrderMissionById"](this.workOrderMissionId);
    }

    public get workOrder(): IWorkOrder {
        return this.$store.getters["productionLines/getWorkOrderById"](this.woMission.workOrderId);
    }

    public get productionLine(): IProductionLine {
        return this.$store.getters["productionLines/getProductionLineById"](this.workOrder.productionLineId);
    }

    public get component(): IComponent {
        return this.workOrder.workOrderComponents.find(woc => woc.workOrderComponentId === this.woMission.workOrderComponentId).component;
    }

    public get waitingFor(): string {
        const waiting = this.$store.state.app.now.getTime() - new Date(this.woMission.creationDate).getTime();
        return `${waiting > 0 ? Math.round(waiting / 1000 / 60) : 0} min`;
    }

    public get type(): string {
        if (this.woMission) {
            switch (this.woMission.type) {
                case WorkOrderMissionType.Supply:
                    return "supply";
                case WorkOrderMissionType.Return:
                    return "return";
            }
        }
        return "";
    }

    constructor() {
        super();

        this.showButtons = false;
        this.cancelReason = "";
    }

    public toggleButtons(): void {
        if (this.$route.name.startsWith("supply") || this.$route.name.startsWith("return")) {
            this.showButtons = this.showButtons ? false : true;
        }
    }

    public async goComponent(): Promise<void> {
        await this.$store.dispatch("productionLines/assigneWorkOrderMission", this.workOrderMissionId);
        if (this.woMission.type === WorkOrderMissionType.Supply) {
            this.$router.push({ name: "supplyComponent", params: { workOrderComponentId: this.woMission.workOrderComponentId.toString() } });
        }
        else if (this.woMission.type === WorkOrderMissionType.Return) {
            this.$router.push({ name: "returnComponent", params: { workOrderComponentId: this.woMission.workOrderComponentId.toString() } });
        }
    }

    public async cancelWorkOrderMission(): Promise<void> {
        await this.$store.dispatch("productionLines/cancelWorkOrderMission", { workOrderMissionId: this.workOrderMissionId, cancelReason: this.cancelReason });
        this.$modal.hide("cancelModal");
    }
}
